<template>
  <div>
    <div class="capsule-item">
      <div class="pg-video-block">
        <div
          class="pg-video-clickbar"
          @click="playVideo"
        >
          <div class="pg-video-playicon" />
          <p>{{ text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  methods: {
    playVideo () {
      this.$emit('playVideo')
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/pages/bias-fx2.scss";
.capsule-item{
    display: inline-block;
    .pg-video-block{
        background-color: color_guide_line('black');
        border-radius: 33px;
        .pg-video-clickbar{
            width:unset;
            top:unset;
            transform:unset;
            position: relative;
            padding:0.3rem;
            .pg-video-playicon{
                display: inline-block;
                vertical-align: middle;
                width: 35px;
                height: 35px;

                &:before{
                    border-width:8px 0 8px 12px;
                    left:5px;
                }
            }
            p{
                display: inline-block;
                vertical-align: middle;
                margin-left: 0.5rem;
                margin-right: 1rem;
                margin-top: 0;
                margin-bottom: 0;
                @include font_guide_line('H6_dark_center');
                font-size:1rem;
            }
        }
    }
}
.pg-video {
    &-block {
        width: 100%;
        background-position: center;
        //height: 100%;
        background-size: cover;
        cursor: pointer;
    }

    &-clickbar {
        width: 100%;
        //height: 120px;
        position: absolute;
        top: 50%;
        left:0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        cursor: pointer;
        &-in-slider{
            position: absolute;
            top:50%;
            @media (max-width: 1200px){
              top:40%;
            }
        }
    }
    &-caption{
        position: absolute;
        left:0;
        right:0;
        top:60%;
        margin: auto;
        font-size: 1.5rem;
        color:#fff;
        text-align: center;
    }

    &-playicon {
        @media (max-width: 551px){
            width: 40px;
            height: 40px;
            border: 2px solid color_guide_line('white-two');
        }
        width: 90px;
        height: 90px;
        position: relative;
        margin: auto;
        border: 1px solid color_guide_line('white');
        border-radius: 45px;
        background-repeat: no-repeat;
        background-position: center;
        background-position: center;
        transition: .5s;
        filter: drop-shadow(0 0 4px #000);

        &:hover {
          background-color: color_guide_line('putty');
          border-color:color_guide_line('putty');
          &:before{
              border-color: transparent transparent transparent color_guide_line('black-four');
          }
        }
        &:active{
          background-color: color_guide_line('dark-beige');
          border-color:color_guide_line('dark-beige');
          &:before{
            border-color: transparent transparent transparent color_guide_line('black-four');
          }
        }
        &:before{
            content:'';
            display: block;
            position:absolute;
            right:0;
            top:0;
            bottom:0;
            margin:auto;
            width: 0;
            height: 0;
            border-style: solid;
            border-width:23px 0 23px 37px;
            left:13px;
            transition: .5s;
            @media (max-width: 551px){
                left:5px;
                border-width: 10px 0 10px 15px;
                border-color: transparent transparent transparent color_guide_line('white-two');
            }
            border-color: transparent transparent transparent color_guide_line('white');
        }
    }

    &-modal {
        position: fixed;
        display: none;
        background-color: rgba(0,0,0,0.9);
        z-index: 9990;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        text-align: center;
        outline: none!important;
    }

    &-close {
        position: fixed;
        z-index: 9994;
        width: 35px;
        height: 35px;
        right: 15px;
        top: 15px;
        opacity: .5;
        transition: opacity .3s;
        -webkit-appearance: none;
        cursor: pointer;
        text-decoration: none;
        text-align: center;
        padding: 0;
        color: #fff;
        font-style: normal;
        font-size: 35px;
        font-family: Arial,Baskerville,monospace;
        line-height: 35px;
        text-shadow: 0 1px 2px rgba(0,0,0,.6);
        border: 0;
        background: none;
        outline: none;
        box-shadow: none;
    }

    &-container {
        position: relative;
        top: 50%;
        height: 0;
        width: 100%;
        padding-top: 56%;
        margin: 0 auto;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);

        @media (min-width: 552px) {
          width: 80%;
          padding-top: 45%;
        }

        iframe {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/video-capsule.vue